import { Spin, message } from 'antd';
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import moment from 'moment';
import { get_invoices } from '../PaymentLambdaUtils';

const InvoiceDetails = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [tableData, setTableData] = useState<any[]>([]);

    useEffect(() => {
        get_invoices().then((res) => {
            const data = JSON.parse(res);
            const transformedData = data.invoices.map((item : any) => ({
                name: item?.name,
                date: moment.unix(item?.date).format('DD-MM-YYYY'),
                card_no: item?.card_no,
                brand : item?.brand,
                download_link: item?.download_link,
            }));
            setTableData(transformedData)
        }).catch((err) => {
            message.error("Failed to get invoices")
        }).finally(() => {
            setLoading(false)
        })
    }, []);

    const columnsData = [
        { title: "Name", key: "name", size: 150 },
        { title: "Date", key: "date", size: 150, },
        { title: "Card No", key: "card_no", size: 70 },
        { title: "Brand", key: "brand", size: 70 },
        { title: "Download", key: "download_link", size: 30 },
    ];

    const columns = useMemo<MRT_ColumnDef<any>[]>(() => {

        if (tableData.length === 0) {
            return [];
        } else {
            return columnsData.map(({ title, key, size }) => {
                if (key === "download_link") {
                    return {
                        accessorKey: key,
                        header: title || "",
                        size: size,
                        Cell: ({ cell }) => {
                            return (
                                <div style={{ paddingLeft: "20px" }} onClick={() => handleDownload(cell.row.original.download_link, cell.row.original.name)}>
                                    <SimCardDownloadOutlinedIcon style={{ color: '#36BDBE', cursor: "pointer" }} />
                                </div>
                            );
                        },
                    };
                }
                else {
                    let data = {
                        accessorKey: key,
                        header: title || "",
                        size: size,
                    }
                    return data
                };

            })
        }

    }, [tableData]);

    const table = useMaterialReactTable({
        columns,
        data: tableData,
        enableSorting: false,
        positionToolbarAlertBanner: 'none',
        rowNumberDisplayMode: "static",
        initialState: {
            showGlobalFilter: true,
            pagination: {
                pageSize: 5,
                pageIndex: 0
            },
        },
    });

    if (!table) {
        return null;
    }

    const handleDownload = (url: string, name : string) => {
        // download file
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download',  name + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <div className="inputData_table_searchable dataIndex_table batch_info invoice_table">
                <Spin spinning={loading}>
                    <div className={`materialReactTableCustom batchCustomTable invoice_table`}>
                        <MaterialReactTable table={table} />
                    </div>
                </Spin>
            </div>

        </>
    );
}

export default InvoiceDetails;
